module.exports = __webpack_public_path__ + "media/images/glyph-sheet-d703eff0f1c8e804ee7b1d1dffe22eeb.svg";